import React from "react";
import DynamicPieChart from "../../components/chart/Piechart";
import DynamicBarChart from "../../components/chart/BarChart";
import DynaminAreaChart from "../../components/chart/AreaChart";
import DistrictDetails from "../../components/filter/districtDetailsFilter/DistrictDetails.tsx";
import "react-datepicker/dist/react-datepicker.css";
import TimeOverview from "../../components/filter/durationFilter/TimeOverview";
import ApplicationStatus from "../../components/applicationStatus/ApplicationStatus";
import StateDetails from "../../components/filter/stateDetailsFilter/MultiSelectDropdown.tsx";
import Count from "../../components/count/Count.tsx";
import Tnmap from "../../components/chart/Tnmap.tsx";
import DynamicColoumChart from "../../components/chart/ColumnChart.tsx";
import Mapcard from "./Mapcard.tsx";
import Successperformance from "../../components/Performanance/Successperformance.tsx";
import DynamicLineChart from "../../components/chart/LineChart.tsx";
import CombinedTwoColumnTwoLineChart from "../../components/chart/CombinedTwoColumnTwoLineChart.tsx";
import DynamicStackedBarChart from "../../components/chart/StackedChart.tsx";
import RuralDetailsCount from "../../components/ruralDetailsCount/RuralDetailsCount.tsx";
import RemarkList from "../../components/remark/RemarkList.tsx";
// Component mapping to dynamically load chart components based on chart_type_name
const componentMapping: { [key: string]: any } = {
  DateFilter: TimeOverview,
  MainFilter: DistrictDetails,
  CombinedTwoColumnsTwoLines: CombinedTwoColumnTwoLineChart,
  StackedBar: DynamicStackedBarChart,
  Scorecard: RuralDetailsCount,
  SecondaryFilter: StateDetails,
  Pie: DynamicPieChart,
  AreaLine: DynaminAreaChart,
  Line: DynamicLineChart,
  Column: DynamicColoumChart,
  Bar: DynamicBarChart,
  ListByCount: Successperformance,
  Map: Tnmap,
  Donut: Count,
  Table: ApplicationStatus,
  Count: Mapcard,
  Remark: RemarkList,
};

interface ModelDashboardProps {
  chartData: any;
}

const ModelDashboard: React.FC<ModelDashboardProps> = ({ chartData }) => {
  // Parse the JSON data if it's a string
  let parsedData;
  try {
    parsedData =
      typeof chartData === "string" ? JSON.parse(chartData) : chartData;
  } catch (error) {
    console.error("Error parsing chartData:", error);
    return (
      <div className="flex items-center justify-center min-h-[400px] text-red-500">
        Error: Invalid chart data format
      </div>
    );
  }

  // Extract chart metadata and values
  const chartMetadata = parsedData?.chartData;
  const chartValue = parsedData?.chartValue;

  if (!chartMetadata) {
    return (
      <div className="flex items-center justify-center min-h-[400px] text-gray-500">
        No chart data available
      </div>
    );
  }

  // Get the chart type name and find the corresponding component
  const chartTypeName = chartMetadata?.chart_type_name;
  const Component = componentMapping[chartTypeName];

  if (!Component) {
    console.warn(`No component found for chart type: ${chartTypeName}`);
    return (
      <div className="flex items-center justify-center min-h-[400px] text-gray-500">
        No component found for chart type: {chartTypeName}
      </div>
    );
  }

  // Prepare the component data structure similar to what the API would return
  const componentData = {
    id: chartMetadata?.id,
    chart_type_name: chartTypeName,
    title: chartMetadata?.title,
    height: chartMetadata?.height,
    date_filter: chartMetadata?.date_filter,
    main_filter: chartMetadata?.main_filter,
    secondary_filter: chartMetadata?.secondary_filter,
    has_tab: chartMetadata?.has_tab,
    has_drilldown: chartMetadata?.has_drilldown,
    drill_down_chart_id: chartMetadata?.drill_down_chart_id,
    has_popup: chartMetadata?.has_popup,
    popup_chart_id: chartMetadata?.popup_chart_id,
    has_navigate: chartMetadata?.has_navigate,
    navigate_chart_id: chartMetadata?.navigate_chart_id,
    parent_id: chartMetadata?.parent_id,
    icon: chartMetadata?.icon,
    color: chartMetadata?.color,
    label_name: chartMetadata?.label_name,
    columns: chartMetadata?.columns,
    sortable: chartMetadata?.sortable,
    chart_value: chartValue,
  };

  // Prepare renderAbleId (empty since we're not using filters in this context)
  const renderAbleId = {
    date_filterable: [],
    main_filterable: [],
    secondary_filterable: [],
  };

  return (
    <div className="w-full h-full">
      {/* Header */}
      {/* <div className="mb-4">
        <h2 className="text-[#434349] text-xl font-semibold">
          {chartMetadata?.title}
        </h2>
      </div> */}

      {/* Content */}
      <div className="w-full">
        <Component
          chartListData={componentData}
          renderAbleId={renderAbleId}
          onDispatch={() => {
            // No-op function since we're not using Redux dispatch in this context
          }}
        />
      </div>
    </div>
  );
};

export default ModelDashboard;
